import {RouteLocationRaw, Router, RouteRecordRaw} from "vue-router";
import {defineAsyncComponent} from "vue";
import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";
import { customAsyncComponent } from "@/functions/customAsyncComponent";
import { WorkspaceId } from "@/sdk";
import { i18n } from "@/i18n";
import { getAccountRouteLocation } from "@/domains/-account/routes";
import router from "@/router";

export function getAccountProfileRouteRecord():RouteRecordRaw{
  return {
    name: 'account_profile',
    path: 'me',
    component: customAsyncComponent(async () => import('./views/ProfileView.vue')),
      
    meta: {
      accountNav: true,
      localeCategories: [
        LOCALE_CATEGORIES.MY_ACCOUNT,
        LOCALE_CATEGORIES.ERRORS,
      ]
    }
  }
}

export function getAccountProfileRouteLocation(workspaceId: WorkspaceId):RouteLocationRaw{
  return { name: 'account_profile', params:{workspaceId} }
}

export function getAccountProfileRouteParams(router: Router): { workspaceId: WorkspaceId; } {
  return {
    workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
  }
}